import { useEffect } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "@/components/Logo";
import { useLang } from "@/i18n/LanguageContext";

const LanguageGate = () => {
  const { chosen, setLang, t } = useLang();

  useEffect(() => {
    if (chosen) return;
    window.__lenis?.stop();
    document.body.style.overflow = "hidden";
    return () => {
      window.__lenis?.start();
      document.body.style.overflow = "";
    };
  }, [chosen]);

  if (chosen) return null;

  return (
    <motion.div
      role="dialog"
      aria-modal="true"
      aria-label={t.gate.label}
      data-testid="language-gate"
      className="fixed inset-0 z-[90] flex items-center justify-center bg-midnight/85 p-6 backdrop-blur-sm"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="w-full max-w-sm border border-gold/30 bg-charcoal p-10 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
      >
        <LogoMark size={44} className="mx-auto" />
        <p className="mt-6 font-sans text-[10px] tracking-[0.4em] text-gold">
          {t.gate.brand}
        </p>
        <p className="mt-6 font-serif text-2xl font-light text-ivory">
          {t.gate.line1}
        </p>
        <p className="mt-2 font-serif text-lg font-light italic text-gold/80">
          {t.gate.line2}
        </p>
        <div className="mt-8 flex flex-col gap-3">
          <button
            type="button"
            onClick={() => setLang("en")}
            data-testid="language-gate-en"
            className="border border-gold/50 px-8 py-3.5 font-sans text-[11px] tracking-[0.3em] text-ivory transition-colors duration-300 hover:bg-gold hover:text-midnight"
          >
            {t.gate.en.toUpperCase()}
          </button>
          <button
            type="button"
            onClick={() => setLang("es")}
            data-testid="language-gate-es"
            className="border border-gold/50 px-8 py-3.5 font-sans text-[11px] tracking-[0.3em] text-ivory transition-colors duration-300 hover:bg-gold hover:text-midnight"
          >
            {t.gate.es.toUpperCase()}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LanguageGate;
